import { NextPage } from 'next';
import React, { useEffect } from 'react';

const withRecaptcha = (Component: React.FC | NextPage) => {
  return function WrapperComponent(props: any) {
    useEffect(() => {
      const script = document.createElement('script');
      script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_KEY}`;
      document.body.append(script);
    }, []);

    return <Component {...props} />;
  };
};

export default withRecaptcha;
